<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary"
                    @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block">
            <div class="title">Select Artifcts</div>
            <div class="body">
                <button class="button btn-primary" @click="modalSearchArtifcts = true">Add</button>

                <div>
                    <draggable v-model="artifacts"
                               class="images"
                               :forceFallback="true">
                        <div class="image"
                             v-for="(item, index) in artifacts"
                             :key="index"
                             :style="{'background-image': `url(${ getMediaUrl(item.image) })` }">
                            <div class="image-title">
                                <div>{{ item.title }}</div>
                                <div>
                                    <select class="select" v-model="item.home_category_id">
                                        <option :value="null">Not selected</option>
                                        <option v-for="(el, key) in home_categories" :key="key" :value="el.id">
                                            {{ el.title }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="edit-buttons">
                                <div class="delete-button" @click="deleteArtifact(index)">
                                    <span class="ico-i icon-delete"></span>
                                </div>
                            </div>
                        </div>
                    </draggable>
                </div>
                <p class="help">Drag to change the order</p>
            </div>
        </div>

        <ArticlesSliderSection ref="articlesSliderSection" targetPage="homepage"/>

        <ModalSearchArtifacts
            :is-open-modal="modalSearchArtifcts"
            @selected="selectedArtifact"
            @closeModal="modalSearchArtifcts = false">
        </ModalSearchArtifacts>


    </div>
</template>

<script>
import ArticlesSliderSection from "../Utils/ArticlesSliderSection";
import FormDefault from "../Utils/Page/FormDefault";
import ModalSearchArtifacts from "../Utils/ModalSearchArtifacts";
import ModalWindow from "../Utils/ModalWindow";
import draggable from "vuedraggable";
import _ from "lodash";


export default {
    name: "Form",
    mixins: [FormDefault],
    components: {
        ArticlesSliderSection,
        ModalSearchArtifacts,
        ModalWindow,
        draggable
    },
    data() {
        return {
            lang: this.$ml.get('pages.homepage'),

            modalSearchArtifcts: false,

            buttons: [],

            typeForm: {},

            pageRouteList: 'homepage',
            pageRouteEdit: 'homepage.edit',
            pageApi: 'homepage',
            pagePermission: 'homepage',

            artifacts: [],
            home_categories: [],

        }
    },

    watch: {

    },

    methods: {
        deleteArtifact(index) {
            this.artifacts.splice(index, 1)
        },
        selectedArtifact(item) {
            this.modalSearchArtifcts = false
            this.artifacts.push(item)
        },

        getMediaUrl(media) {
            return media.preview_url_cdn_query ?? media.url_preview ?? media.url
        },
        setExtraDataCreate() {
            this.artifacts = this.dictionaries.artifacts
            this.home_categories = this.dictionaries.home_categories
        },

        appendDataSave() {
            return {
                artifacts: this.artifacts
            }
        },

        saveForm() {
            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }

            // First we save articles, then it will call our saving of artifcts
            const saveArtifcts = function() {
                this.saveFormDefault();
            }
            const saveArtifctsBinded = saveArtifcts.bind(this)
            this.$refs.articlesSliderSection.saveForm(saveArtifctsBinded);

        }
    }
}
</script>

